export const scrollByOffset = (
  container: HTMLDivElement,
  offset: number,
  behavior: ScrollBehavior,
) => {
  if (typeof container.scrollBy === 'function') {
    container.scrollBy({ left: offset, behavior });
    return;
  }

  const nextScrollLeft = container.scrollLeft + offset;
  container.scrollTo({ left: nextScrollLeft, behavior });
};
